<script>
import McHeader from "../McHeader/index.vue";
import McLang from "../McLang.vue";
import McTime from "../McTime.vue";
import AccountMenu from "../AccountMenu.vue";

export default {
  name: "HeaderMenu",
  components: {
    McHeader,
    McLang,
    McTime,
    AccountMenu,
  },
  data() {
    return {
      systemTpe: "rss",
      // #fff
      backgroundColorStyle: {
        test: "#FFFFFF",
        staging: "#FFFFFF",
        production: "#FFFFFF",
      },
      lxConfig: {
        cid: "c_osg_b_5qfaje9e",
        changeLangBid: "b_osg_b_ilpn87a1_mc",
        initLangBid: "b_osg_b_ilpn87a1_mv",
      },
    };
  },
};
</script>

<template>
  <mc-header :system-type="systemTpe" :background-color="backgroundColorStyle">
    <template #right>
      <McTime />
      <McLang :lx-config="lxConfig" />
      <AccountMenu />
    </template>
  </mc-header>
</template>

<style>
:root[dir="rtl"] .mtd-dropdown-menu-item {
  text-align: right;
}

:root[dir="rtl"] .mtd-menu {
  text-align: right;
}
</style>
<style scoped>
.mtd-menu {
  width: auto;
}
.mc-header {
  height: 56px !important;
  padding-left: 0px;
  padding-right: 0px;
  padding-inline-start: 14px;
  padding-inline-end: 24px;
  width: 100%;
}

.supplier-name {
  font-size: 16px;
  font-weight: 500;
  color: #222222;
}
</style>
